// extracted by mini-css-extract-plugin
export var actionButton = "_ma-0";
export var actionMenuContainer = "_ma-i";
export var bubble = "_ma-2";
export var bubbleActionMenu = "_ma-j";
export var bubbleContext = "_ma-6";
export var bubbleItems = "_ma-7";
export var customer = "_ma-3";
export var divider = "_ma-8";
export var fileList = "_ma-9";
export var hiddenComment = "_ma-o";
export var infoAbove = "_ma-a";
export var internal = "_ma-4";
export var lightActionButton = "_ma-1";
export var link = "_ma-b";
export var merchant = "_ma-5";
export var message = "_ma-c";
export var profilePicture = "_ma-e";
export var quillToolbarContainer = "_ma-f";
export var senderDate = "_ma-g";
export var senderDateCustomer = "_ma-h";
export var senderName = "_ma-d";
export var time = "_ma-k";
export var uploadedImage = "_ma-l";
export var username = "_ma-m";
export var xsmall = "_ma-n";